<h1 class="mt-0">
    <i class="fa fa-truck me-3"></i>

    {{ opts.title ? opts.title : opts.objectLabel + 's' }}
    <a class="float-right btn btn-primary" [routerLink]="formService.getRoute(opts.formSlug)">
        <i class="fa fa-plus"></i> New <span class="d-none d-sm-inline">{{ opts.objectLabel }}</span>
    </a>
</h1>

<ngxh6-filter [label]="opts.objectLabel" [key]="opts.queryKey" [className]="opts.apiClassName" [showFilter]="true" [archivable]="true" [showSearch]="true"></ngxh6-filter>

<div class="content-container">
    @if (collectionSize) {
        <ngxh6-pagination [countLabel]="opts.objectLabel" [key]="opts.queryKey" [collectionSize]="collectionSize" [showItemsPerPage]="true"></ngxh6-pagination>
    }
    @if (response$ | async; as response) {
        <ngxh6-cache-notice [show]="complete" [data]="response"></ngxh6-cache-notice>
        @if (response && response.data.length) {
            <div class="table-responsive table-flush">
                <table class="table table-hover table-sticky-actions" [class.dim]="!complete">
                    <thead>
                        <tr>
                            <th orderby [key]="opts.queryKey" [field]="'name'" colspan="2">Name</th>
                            <th>Community</th>
                            <th>Position Title</th>
                            <th>Role(s)</th>
                            <th class="text-center" orderby [key]="opts.queryKey" [field]="'locked'">Locked</th>
                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of response.data; track trackById(i, item); let i = $index) {
                            <ngxh6-offline-indicator [model]="item"></ngxh6-offline-indicator>
                            <tr>
                                <td class="align-middle"><ngxh6-usericon [showTooltip]="false" [user]="item" class="me-0"></ngxh6-usericon></td>
                                <td class="align-middle" style="width: 100%; min-width: 180px">
                                    <a [routerLink]="'' + item.id">{{ item.name }}</a>
                                </td>
                                <td class="align-middle small" style="width: 100%; min-width: 180px">
                                    @if (item.communities?.length) {
                                        <span [ngbTooltip]="(item.communities | pluck: 'string').join(', ')">
                                            {{ item.communities[0].string }}
                                            @if (item.communities.length > 1) {
                                                <span class="font-weight-bold">(+{{ item.communities.length - 1 }})</span>
                                            }
                                        </span>
                                    }
                                </td>
                                <td class="align-middle" style="min-width: 150px">
                                    <small>{{ item.staffDetail.positionTitle }}</small>
                                </td>
                                <td class="align-middle" style="min-width: 160px">
                                    @if (item.roleLabels?.length) {
                                        <small class="text-nowrap" [ngbTooltip]="item.roleLabels?.join(', ')">
                                            {{ item.roleLabels[0] }}
                                            @if (item.roleLabels?.length > 1) {
                                                <strong>(+{{ item.roleLabels?.length - 1 }})</strong>
                                            }
                                        </small>
                                    }
                                </td>
                                <td class="align-middle text-center">
                                    @if (!item.locked) {
                                        <div class="badge badge-pill bg-success">
                                            <i class="fa fa-unlock"></i>
                                        </div>
                                    }
                                    @if (item.locked) {
                                        <div class="badge badge-pill bg-danger">
                                            <i class="fa fa-lock"></i>
                                        </div>
                                    }
                                </td>
                                <td class="align-middle text-right" style="min-width: 120px">
                                    <div class="btn-group" ngbDropdown container="body">
                                        <a class="btn btn-gray" [routerLink]="'' + item.id">View</a>
                                        <button class="btn btn-gray" ngbDropdownToggle></button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <button class="dropdown-item" (click)="modals.form(opts.formSlug, item.id, item)">
                                                <i class="fa fa-fw fa-pencil me-3"></i>Quick Edit
                                            </button>
                                            <button class="dropdown-item" (click)="modals.notes(item.id)"><i class="fa fa-fw fa-note-sticky me-3"></i>View Notes</button>
                                            @if (user.isGranted('ROLE_ADMIN')) {
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item warning" (click)="user.impersonate(item.email)">
                                                    <i class="fa fa-fw fa-wand-sparkles me-3"></i>Impersonate
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (response && !response.data.length) {
            <p class="my-4">No Users to show.</p>
        }
    } @else {
        @if (error) {
            <ngxh6-api-error [error]="error"></ngxh6-api-error>
        } @else {
            <ngxh6-loading-spinner></ngxh6-loading-spinner>
        }
    }
</div>
